export default "__VITE_ASSET__BBRAuXnt__"